module.exports = __webpack_public_path__ + "img/izunjing.9bc1927c.png";